import { Alert } from 'react-bootstrap';

export function DataCollectionNotice() {
	return (
		<Alert variant="secondary" className="mb-4">
			Notice: The personal data collected on this form is classified as a
			public record and may be made available to the public as provided by{' '}
			<a
				href="https://le.utah.gov/xcode/Title63G/Chapter2/63G-2-S201.html?v=C63G-2-S201_2026050620260701"
				target="_blank"
				rel="noreferrer">
				Utah Code Section 63G-2-201
			</a>
			.
		</Alert>
	);
}
